import { render, staticRenderFns } from "./PrivateMessage.vue?vue&type=template&id=0a1f0dce&scoped=true"
import script from "./PrivateMessage.vue?vue&type=script&lang=js"
export * from "./PrivateMessage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a1f0dce",
  null
  
)

export default component.exports